import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormBuilder, Validators } from '@angular/forms';
import { UserService } from 'src/app/services/user.service';
import { faWarning, faFire, faUsers } from '@fortawesome/free-solid-svg-icons';
import { DialogService } from 'src/app/services/dialog.service';
import { ConfirmationToastComponent } from 'src/app/components/confirmation-toast/confirmation-toast.component';
import { ReportService } from 'src/app/services/report.service';
import { ReportForest } from 'src/app/models/reportForest.model';

@Component({
  selector: 'app-sign-report',
  templateUrl: './sign-report.component.html',
  styleUrl: './sign-report.component.scss',
  standalone: false
})
export class SignReportComponent implements OnInit {
  faWarning = faWarning;
  faFire = faFire;
  faUsers = faUsers;

  leadDisabled = false;
  interregionalDisabled = false;

  userList: any[] = [];
  alertLead: any;
  skillList: any[] = [];
  is_WO = false;
  is_RO = false;

  signOptions: any[] = []; // sign on behalf options
  forests: any[] = []
  areaName = "Forest"

  form = this.formBuilder.group({
    behalfOf: [{ report_signature_id: 0, name: '', areas: <any>[] }],
    first_name: [""],
    last_name: [""],
    title: [""],
    forest: [[""]],
    confirm: [false, Validators.requiredTrue],
  });

  constructor(
    public dialogRef: MatDialogRef<SignReportComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private readonly formBuilder: FormBuilder,
    public readonly toast: ConfirmationToastComponent,
    private readonly userService: UserService,
    private readonly dialogService: DialogService,
    public readonly reportService: ReportService,
  ) {
  }

  ngOnInit(): void {
    this.form.patchValue({ //clear for validation
      behalfOf: undefined
    })
    if (this.data.signType == 'WO')
      this.getWOOfficers();
    else if (this.data.signType == 'RO')
      this.getRegionalOfficers();
    else
      this.getLineOfficers();
  }


  getLineOfficers() {
    let forestNames: string[] = this.data.report.forests.map((forest: ReportForest) => forest.forest_name)
    let LONames: string[] = this.data.report.forests.map((forest: ReportForest) => forest.line_officer.user_id)
    this.userService.getUserList("LO").subscribe((data: any) => {
      let LOs = data.users.filter((user: any) => {
        return user.baer_roles.find((role: any) => role.baer_role.type == "FOLO"
          && forestNames.includes(role.forest_name ?? user.forest_name)
          && LONames.includes(user.user_id))
      })
      LOs = LOs.map((user: any) => { return { report_signature_id: 0, name: user.first_name + " " + user.last_name, areas: user.baer_roles.filter((role: any) => role.baer_role.type == "FOLO" && forestNames.includes(role.forest_name ?? user.forest_name) && LONames.includes(user.user_id)).map((role: any) => role.forest_name ?? user.forest_name) } })
      this.userService.getLoginUser().subscribe((loginUser: any) => {
        LOs.forEach((user: any) => {
          if (user.name == loginUser.first_name + " " + loginUser.last_name)
            user.name = "Myself"
        })
      })
      this.signOptions = LOs
    })
    this.forests = forestNames;
    // this.form.patchValue({
    //   forest: forestNames
    // })
    this.areaName = "Forest"
  }

  getRegionalOfficers() {
    this.userService.getLoginUser().subscribe((loginUser: any) => {
      let signatures = this.data.report.signatures.filter((signature: any) => signature.signature_type_id == 1)
      signatures.forEach((signature: any) => {
        this.userService.getUser(signature.user_id).subscribe((data: any) => {
          if (signature.user_id == loginUser.user_id)
            this.signOptions.push({ report_signature_id: signature.report_signature_id, name: "Myself" })
          else
            this.signOptions.push({ report_signature_id: signature.report_signature_id, name: data.users[0].first_name + " " + data.users[0].last_name })
        })
      })
    })
    this.areaName = "Region"
  }

  getWOOfficers() {
    this.userService.getLoginUser().subscribe((loginUser: any) => {
      let signatures = this.data.report.signatures.filter((signature: any) => signature.signature_type_id == 2)
      signatures.forEach((signature: any) => {
        this.userService.getUser(signature.user_id).subscribe((data: any) => {
          if (signature.user_id == loginUser.user_id)
            this.signOptions.push({ report_signature_id: signature.report_signature_id, name: "Myself" })
          else
            this.signOptions.push({ report_signature_id: signature.report_signature_id, name: data.users[0].first_name + " " + data.users[0].last_name })
        })
      })
    })
    this.areaName = "WO"
  }

  sign() {
    let signature_type_id = 0
    let regional_approval_status_id: any = undefined
    let wo_approval_status_id: any = undefined

    let new_status: any = undefined
    if (this.data.report.authorization_status_id == 0) { // signature requested from FOLO
      new_status = 3
      if (this.data.report.report_type == "No Treatment") {
        new_status = 7 // No Funding
      }
    } else if (this.data.report.authorization_status_id == 1) {  // signature requested from ROLO
      new_status = 5 // REVIEW WO FUNDING
      if (!this.data.requiresWOFunding) {
        new_status = 4 // RO FUNDING AUTHORIZED
      }
      regional_approval_status_id = 2
    } else if (this.data.report.authorization_status_id == 2) {  // signature requested from WO
      new_status = 6
      wo_approval_status_id = 2
    }

    let allSigned = true



    let promises = []

    if (this.data.signType == "WO") {
      promises.push(this.editSignature("WO"))

    } else if (this.data.signType == "RO") {
      promises.push(this.editSignature("RO"));
    } else {
      let areas = this.form.value.behalfOf?.areas;
      this.forests.forEach((area: string) => {
        if (this.data.report.signatures.find((signature: any) => signature.signature == area)) {
          areas = areas.filter((selectedArea: string) => selectedArea != area)
          return
        }
        if (this.form.value.behalfOf?.areas.find((selectedArea: any) => selectedArea == area)) return;
        allSigned = false
      })
      areas.forEach((area: string) => {
        promises.push(this.createSignature(signature_type_id, area ?? ''))
      })
    }

    if (allSigned) {
      this.updateReportStatus(new_status, regional_approval_status_id, wo_approval_status_id)
    }

    Promise.all(promises).then((result) => {

      if (this.data.report.authorization_status_id == 2)
        this.toast.openSuccessSnackBar(`Report successfully signed and authorized by WO Line Officer.`);
      else if (this.data.report.authorization_status_id == 1)
        this.toast.openSuccessSnackBar(`Report successfully signed by regional line officer.`);
      else
        this.toast.openSuccessSnackBar(`${this.data.report.baer_name} assessment has been updated.`);
      this.dialogRef.close(true);
    }).catch((error: any) => {
      this.dialogService.closeSpinner()
      this.toast.openErrorSnackBar(`There was an error loading the report.`, "Please refresh to try again.");
    })
  }

  updateReportStatus(new_status: number, regional_approval_status_id: number, wo_approval_status_id: number) {
    this.reportService.updateReport({
      report_id: this.data.report.report_id,
      authorization_status_id: new_status,
      regional_approval_status_id: regional_approval_status_id,
      wo_approval_status_id: wo_approval_status_id,
    }).subscribe({
      next: (response: any) => {
      },
      error: (response: any) => {
        this.toast.openErrorSnackBar(`There was an error updating ${this.data.report.baer_name}.`, "Please try editing the assessment again.");
        this.dialogRef.close();
      },
    })
  }

  createSignature(signature_type_id: number, area: string) {
    return new Promise((resolve, reject) => {
      this.reportService.createReportSignature({
        report_id: this.data.report.report_id,
        signature_type_id: signature_type_id,
        region: this.data.user.region,
        signing_for: this.form.value.behalfOf?.name,
        name: this.form.value.first_name + " " + this.form.value.last_name,
        title: this.form.value.title,
        signature: area,
      }).subscribe({
        next: (response: any) => {
          resolve(null)
        },
        error: (response: any) => {
          reject(new Error(response))
          this.toast.openErrorSnackBar(`There was an error updating ${this.data.report.baer_name}.`, "Please try editing the assessment again.");
          this.dialogRef.close();
        },
      })
    })
  }

  editSignature(signature: string) {
    this.reportService.editReportSignature({
      signing_for: this.form.value.behalfOf?.name,
      name: this.form.value.first_name + " " + this.form.value.last_name,
      title: this.form.value.title,
      signature: signature,
    }, this.form.value.behalfOf?.report_signature_id.toString() ?? '').subscribe({
      next: (response: any) => {
      },
      error: (response: any) => {

        this.toast.openErrorSnackBar(`There was an error updating the rport.`, "Please try again.");

      },
    })
  }
}
